export const careerQuiz = {
  title: 'What career is right for you?',
  questions: [
    {
      question: 'What do you enjoy doing in your free time?',
      answers: [
        { text: 'Building things', isCorrect: false },
        { text: 'Solving puzzles', isCorrect: true },
        { text: 'Helping people', isCorrect: false },
        { text: 'Creating art', isCorrect: false },
      ],
    },
    {
      question: 'What subject did you enjoy most in school?',
      answers: [
        { text: 'Math', isCorrect: true },
        { text: 'Art', isCorrect: false },
        { text: 'Science', isCorrect: false },
        { text: 'History', isCorrect: false },
      ],
    },
    {
      question: 'What kind of work environment do you prefer?',
      answers: [
        { text: 'A quiet, focused environment', isCorrect: true },
        { text: 'A collaborative, team-oriented environment', isCorrect: false },
        { text: 'A fast-paced, dynamic environment', isCorrect: false },
        { text: 'A creative, unstructured environment', isCorrect: false },
      ],
    },
  ],
  results: {
    0: 'You might enjoy a career in a creative field, such as writing or design.',
    1: 'You might enjoy a career in a technical field, such as engineering or programming.',
    2: 'You might enjoy a career in a helping profession, such as teaching or healthcare.',
    3: 'You are a problem solver! A career in software engineering or data science could be a great fit.',
  },
};
